/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

import { giveFeedbackGeneralAnalysisJSX } from './jsx/giveFeedbackGeneralAnalysisJSX'
import { submitAndSaveFeedbackButtonsJSX } from './jsx/submitAndSaveFeedbackButtons'

import { viewHingeProfileTabJSX } from '../profile/view/hinge/viewHingeProfileTabJSX'

import { viewBumbleProfileTabJSX } from '../profile/view/bumble/viewBumbleProfileTabJSX'

import { viewTinderProfileTabJSX } from '../profile/view/tinder/viewTinderProfileTabJSX'

import useWindowDimensions from '../../helpers/windowDimensions'
import { getPayload, userIsAuthenticated, getTokenFromLocalStorage } from '../../helpers/storage'
import { seoPageTags } from '../../helpers/analytics'
import { standardSpinner } from '../../helpers/spinners'
import { navbarHeight, hingeProfileBackgroundColor, dashboardNavbarHeight, footerHeight, positionChangeWidthSm } from '../../helpers/variableDefaults'
import { makeTabIndex } from '../../helpers/formatting'
import { standardErrorContainer } from '../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../helpers/typographies'
import { standardButton } from '../../helpers/buttons'


// Give Feedback Page
const GiveFeedback = (props) => {

  const { isFriendReview, friendProfileReview } = props
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()
  
  // Navigate
  const navigate = useNavigate()

  // Params
  const { reviewerUserId, datingProfileId, profileReviewId } = useParams()

  // Payload
  const payload = getPayload()

  // Dashboard Navigation
  const [user, setUser] = useState({})
  // const [datingProfile, setDatingProfile] = useState({})
  const [profileReview, setProfileReview] = useState(isFriendReview && 'friendProfileReview' in props && friendProfileReview !== null && friendProfileReview !== undefined && Object.keys(friendProfileReview).length > 0 ? JSON.parse(JSON.stringify(friendProfileReview)) : {})
  const [previousProfileReview, setPreviousProfileReview] = useState(isFriendReview && 'friendProfileReview' in props && friendProfileReview !== null && friendProfileReview !== undefined && Object.keys(friendProfileReview).length > 0 ? JSON.parse(JSON.stringify(friendProfileReview)) : {})

  const [viewTinderImageIndex, setViewTinderImageIndex] = useState(0)

  // Viewing States
  const [showSubcaption, setShowSubcaption] = useState({
    mediaItem1: false,
    mediaItem2: false,
    mediaItem3: false,
    mediaItem4: false,
    mediaItem5: false,
    mediaItem6: false,
    mediaItem7: false,
    mediaItem8: false,
    mediaItem9: false,
  })
  const [mediaIsLoading, setMediaIsLoading] = useState({
    mediaItem1: false,
    mediaItem2: false,
    mediaItem3: false,
    mediaItem4: false,
    mediaItem5: false,
    mediaItem6: false,
    mediaItem7: false,
    mediaItem8: false,
    mediaItem9: false,
  })

  //Keeps track of which tab we are in, default is View at index 0
  const [value, setValue] = useState(0)

  // Save Successful
  const [saveSuccessful, setSaveSuccessful] = useState(false)
  const [submitReviewSuccessful, setSubmitReviewSuccessful] = useState(false)

  // Loading
  const [loading, setLoading] = useState(false)
  const [loadingUpdatedFeedback, setLoadingLoadingUpdatedFeedback] = useState(false)

  // Errors
  const [errors, setErrors] = useState(false)

  useEffect(() => {
    // console.log('GiveFeedback useEffect runs')

    // console.log('isFriendReview ->', isFriendReview)
    // console.log('friendProfileReview in props ->', 'friendProfileReview' in props)
    // console.log('friendProfileReview === null ->', friendProfileReview === null)
    // console.log('friendProfileReview === undefined ->', friendProfileReview === undefined)
    // console.log('Object.keys(friendProfileReview).length === 0 ->', Object.keys(friendProfileReview).length === 0)
    if (isFriendReview && ((!('friendProfileReview' in props)) || (friendProfileReview === null || friendProfileReview === undefined) || Object.keys(friendProfileReview).length === 0)) {
      // console.log('this is triggered')
      navigate(`/login`)
    } else if (isFriendReview) {
      // console.log('friend review')
    } else if ((!userIsAuthenticated() || !reviewerUserId)) {
      navigate(`/login`)
    } else if ((reviewerUserId !== payload.sub)) {
      navigate(`/dashboard/${payload.sub}`)
      // reloadView()
    } else {
      const fetchData = async () => {
        setLoading(true)
        //   // console.log('userId ->', userId)
        try {
          const { data: retrievedUser } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${payload.sub}`, {
            headers: {
              Authorization: `Bearer ${getTokenFromLocalStorage()}`,
            },
          })

          // console.log('retrievedUser ->', retrievedUser)

          if (
            retrievedUser._id === payload.sub
            && 'reviewerProfile' in retrievedUser
            && 'profileReviews' in retrievedUser.reviewerProfile 
            && retrievedUser.reviewerProfile.profileReviews !== null
            && retrievedUser.reviewerProfile.profileReviews.length > 0
            && retrievedUser.reviewerProfile.profileReviews.filter((profileReview, reviewIndex) => profileReview._id === profileReviewId).length > 0
          ) {
            // console.log('states should set')
            // Set User State
            setUser(retrievedUser)

            // console.log('profile review ->', retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0].profileReviews.filter((reviewItem, reviewItemIndex) => reviewItem._id === profileReviewId)[0])
            const profileReviewToSet = retrievedUser.reviewerProfile.profileReviews.filter((profileReview, reviewIndex) => profileReview._id === profileReviewId)[0]
            setPreviousProfileReview(JSON.parse(JSON.stringify(profileReviewToSet)))
            setProfileReview(JSON.parse(JSON.stringify(profileReviewToSet)))

            setLoading(false)
            // console.log('no longer loading')

          } else {
            console.log('states should not set')
            useNavigate(`/dashboard/${payload.sub}`)
            setLoading(false)
          }

        } catch (err) {
          // console.log(err)

          navigate('/')
          setLoading(false)
        }
      }
  
      
      fetchData()
    }

  }, [])

  useEffect(() => {
    // console.log('value useEffect Runs')

  }, [value])

  useEffect(() => {
    // console.log('profileReview useEffect Runs')
    // console.log('saveSuccessful ->', saveSuccessful)

    setSaveSuccessful(false)
    setErrors(false)

  }, [profileReview])

  useEffect(() => {
    // console.log(useEffect Runs')

  }, [loading, loadingUpdatedFeedback])

  // Handles tab changes
  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleBackToDashboard = () => {
    console.log('handleBackToDashboard runs')
    navigate(`/dashboard/${payload.sub}`)
  }


  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        'Give Feedback'
      )}

      {/* Body */}
      {loading ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        : 
        <Box 
          sx={{ 
            mb: 4,
            width: '100%',
            minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
          }}
        >
          {submitReviewSuccessful || (Object.keys(profileReview).length > 0 && 'reviewSubmitted' in profileReview && profileReview.reviewSubmitted)
            ?
            <Box
              sx={{
                mt: 8,
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              <Typography
                textAlign={'center'}
                sx={{
                  width: '100%',
                  fontWeight: 'bold',
                  fontSize: '18px',
                }}
              >
                Review Submitted Successfully!
              </Typography>

              {!isFriendReview && standardButton(
                `Back to Dashboard`,
                'button',
                'contained',
                false,
                'primary', 
                4,
                0,
                0,
                '220px',
                '45px',
                handleBackToDashboard
              )}

            </Box>
            :
            <>
              {/* Back to Dashboard Button */}
              <Box
                sx={{
                  mb: 0,
                  width: '100%',
                  display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'column', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {!isFriendReview && standardButton(
                  'Back to Dashboard', 
                  'button',
                  'text',
                  false,
                  'secondary', 
                  width >= positionChangeWidthSm ? 2 : 2,
                  0,
                  0,
                  '250px', 
                  '45px', 
                  handleBackToDashboard
                )}
              </Box>

              {/* Tabs */}
              <Box 
                sx={{ 
                  mt: 1, 
                  width: '100%',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  textColor="primary"
                  indicatorColor="primary"
                  aria-label="primary tabs example"
                  variant={'standard'}
                  sx={{ 
                    // backgroundColor: 'yellow',
                    // width: '90vw', maxWidth: '375px',
                    // width: width < superSmallScoreboardWidth ? '100%' : '275px',
                    // borderTop: 1, borderColor: 'divider',
                    borderBottom: 1, borderColor: 'divider',
                    // display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {/* {['View', 'Feedback'].map((tabName, tabIndex) => ( */}
                  {['Feedback', 'View'].map((tabName, tabIndex) => (
                    <Tab key={tabIndex} label={tabName} {...makeTabIndex(tabIndex)} />
                  ))}
                </Tabs>
              </Box>


              {/* Tab Panels */}

              {/* Feedback Tabs */}
              {/* Hinge */}
              {'type' in profileReview && profileReview.type === 'hinge' && 
                viewHingeProfileTabJSX(value, 0, true, isFriendReview, profileReview, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview)
              }

              {/* Bumble */}
              {'type' in profileReview && profileReview.type === 'bumble' && 
                viewBumbleProfileTabJSX(value, 0, true, isFriendReview, profileReview, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview)
              }

              {/* Tinder */}
              {'type' in profileReview && profileReview.type === 'tinder' && 
                viewTinderProfileTabJSX(value, 0, true, isFriendReview, profileReview, user, viewTinderImageIndex, setViewTinderImageIndex, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview)
              }


              {/* View Tabs */}
              {/* Hinge */}
              {'type' in profileReview && profileReview.type === 'hinge' && 
                viewHingeProfileTabJSX(value, 1, false, isFriendReview, profileReview, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview)
              }

              {/* Bumble */}
              {'type' in profileReview && profileReview.type === 'bumble' && 
                viewBumbleProfileTabJSX(value, 1, false, isFriendReview, profileReview, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview)
              }


              {/* Tinder */}
              {'type' in profileReview && profileReview.type === 'tinder' && 
                viewTinderProfileTabJSX(value, 1, false, isFriendReview, profileReview, user, viewTinderImageIndex, setViewTinderImageIndex, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview)
              }
              
              {value === 0 && 'type' in profileReview && profileReview.type.length > 0 &&
                <>
                  {/* General Analysis */}
                  <Box
                    sx={{
                      mt: 2, mb: 2, py: 3, px: 2,
                      backgroundColor: hingeProfileBackgroundColor,
                      // backgroundColor: 'black',
                      // width: '90%', 
                      width: width >= positionChangeWidthSm ? '90vw' : '100vw', 
                      // maxWidth: '600px',
                      maxWidth: '400px',
                      boxShadow: 3, 
                      borderRadius: 3,
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                    }}
                  >
                    {giveFeedbackGeneralAnalysisJSX(
                      profileReview, 
                      setProfileReview, 
                      width, 
                      errors, 
                      setErrors, 
                      loading, 
                      setLoading
                    )}
                  </Box>

                  {/* Save and Submit Buttons */}
                  <Box
                    sx={{
                      mt: 2, mb: 8, py: 3, px: 2,
                      backgroundColor: hingeProfileBackgroundColor,
                      // backgroundColor: 'black',
                      width: '90%', 
                      // maxWidth: '600px',
                      maxWidth: '400px',
                      boxShadow: 3, 
                      borderRadius: 3,
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                    }}
                  >
                    {!loadingUpdatedFeedback && 
                      submitAndSaveFeedbackButtonsJSX(
                        isFriendReview,
                        profileReview, setProfileReview, 
                        width, 
                        errors, setErrors, 
                        loadingUpdatedFeedback, setLoadingLoadingUpdatedFeedback,
                        saveSuccessful, setSaveSuccessful, 
                        submitReviewSuccessful, setSubmitReviewSuccessful,
                        previousProfileReview, setPreviousProfileReview
                      )
                    }
                    
                    {loadingUpdatedFeedback &&
                      advisoryTypography(
                        `Uploading changes...`
                      )
                    }

                    {!loadingUpdatedFeedback && saveSuccessful &&
                      saveSuccessfulTypography()
                    }

                    {!loadingUpdatedFeedback && errors &&
                      standardErrorContainer(
                        `There was an error uploading your changes. Check your Internet connection and try again.`,
                        0,
                        0
                      )
                    }

                  </Box>
                </>
              }
            </>
          }

        </Box>
      }
    </>
  )
}

export default GiveFeedback